module.exports = __webpack_public_path__ + "static/img/r_015.0067abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_015.jpg
// module id = Xs47
// module chunks = 1